import { render, staticRenderFns } from "./DisposicionPasivaCard.vue?vue&type=template&id=7a5b3cee&"
import script from "./DisposicionPasivaCard.vue?vue&type=script&lang=js&"
export * from "./DisposicionPasivaCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports